var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "max-w-5xl mx-auto" }, [
    _c("div", { staticClass: " my-10" }, [
      _c(
        "div",
        { staticClass: "bg-white overflow-hidden shadow rounded-lg mt-10" },
        [
          _vm._m(0),
          _vm._m(1),
          !_vm.shouldShowExtensionLink
            ? _c("div", { staticClass: "bg-white shadow sm:rounded-lg" }, [
                _c("div", { staticClass: "px-4 py-5 sm:p-6" }, [
                  _c(
                    "div",
                    {
                      staticClass: "sm:flex sm:items-start sm:justify-between"
                    },
                    [
                      _vm._m(2),
                      _c(
                        "div",
                        {
                          staticClass:
                            "mt-5 sm:mt-0 sm:ml-6 sm:flex-shrink-0 sm:flex sm:items-center"
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "inline-flex rounded-md shadow-sm" },
                            [
                              _vm.store.plan !== "advanced"
                                ? _c(
                                    "button",
                                    {
                                      staticClass:
                                        "inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition ease-in-out duration-150",
                                      attrs: { type: "button" },
                                      on: { click: _vm.gotoPlans }
                                    },
                                    [_vm._v(" Upgrade now ")]
                                  )
                                : _vm._e()
                            ]
                          )
                        ]
                      )
                    ]
                  )
                ])
              ])
            : _vm._e(),
          _vm.shouldShowExtensionLink
            ? _c("div", { staticClass: "bg-white shadow sm:rounded-lg" }, [
                _c("div", { staticClass: "px-4 py-5 sm:p-6" }, [
                  _c(
                    "div",
                    {
                      staticClass: "sm:flex sm:items-start sm:justify-between"
                    },
                    [
                      _vm._m(3),
                      _c(
                        "div",
                        {
                          staticClass:
                            "mt-5 sm:mt-0 sm:ml-6 sm:flex-shrink-0 sm:flex sm:items-center"
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "inline-flex rounded-md shadow-sm" },
                            [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition ease-in-out duration-150",
                                  attrs: { type: "button" },
                                  on: { click: _vm.openDownload }
                                },
                                [_vm._v(" Add to chrome ")]
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  )
                ])
              ])
            : _vm._e()
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "border-b border-gray-200 px-4 py-5 sm:px-6" },
      [_c("h1", [_vm._v("Whatsapp Broadcast extension")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "px-4 py-5 sm:p-6" }, [
      _c(
        "div",
        { staticClass: "mt-2 mb-6 max-w-xl text-sm leading-5 text-gray-500" },
        [
          _vm._v(
            " Broadcast your messages to your customers on your own whatsapp number. "
          )
        ]
      ),
      _c("img", { attrs: { src: require("../../assets/broadcastextn.png") } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h3", { staticClass: "text-lg leading-6 font-medium text-gray-900" }, [
        _vm._v(" Upgrade to Advanced plan use this feature ")
      ]),
      _c(
        "div",
        { staticClass: "mt-2 max-w-xl text-sm leading-5 text-gray-500" },
        [_c("p")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h3", { staticClass: "text-lg leading-6 font-medium text-gray-900" }, [
        _vm._v(" Download Chrome Extension ")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }